import { useState, useEffect } from 'react';
import { privateFetch } from '../../../../utils/apiHelper';
import { useAccountContext } from '../../../../contexts/AccountContext';
import { CONSTANT } from '../../../../utils/constants';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useImageCompressingContext } from '../../../../contexts/ImageCompressingContext';
import { Dialog } from 'primereact/dialog';

function ImageCompressing() {
  const [loadingStep, setLoadingStep] = useState(0);
  const { imageCompressingContext, setImageCompressingContext } = useImageCompressingContext();

  const { accountContext } = useAccountContext();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!imageCompressingContext) return;

    const compressAll = async () => {
      setLoadingStep(0);

      for (const imgSizes of CONSTANT.shared.imageSizes) {
        await resizeImage(imageCompressingContext, imgSizes);
      }

      setImageCompressingContext(undefined);
    };

    compressAll();
  }, [imageCompressingContext]);

  const resizeImage = async (imageObj, imgSizes) => {
    setVisible(true);
    const formData = new FormData();
    formData.append('file', imageObj.file);

    await privateFetch(
      'PUT',
      'resources',
      `/cu/${accountContext.id}/image/${imageObj.image.id}/?max_width=${imgSizes.width}&size=${imgSizes.size}`,
      null,
      formData,
      false,
      true
    );

    setLoadingStep((prev) => prev + 1);
  };

  useEffect(() => {
    if (loadingStep === 5) {
      setImageCompressingContext(undefined);
      setVisible(false);
    }
  }, [loadingStep]);

  return (
    <div className="card flex justify-content-center">
      <Dialog
        header="Compression des images"
        visible={visible}
        style={{ width: '32rem' }}
        closable={false}
        draggable={false}
        onHide={() => {
          if (!visible) return;
          setVisible(false);
        }}>
        <div className="flex flex-col items-center justify-center gap-5 p-6 bg-white rounded-lg">
          {/* Spinner */}
          <ProgressSpinner style={{ width: '55px', height: '55px' }} />

          {/* Texte */}
          <div className="flex flex-col items-center text-center gap-2">
            <span className="text-slate-800 text-lg font-semibold">Compression en cours...</span>

            <span className="text-slate-500 text-sm">
              Étape {loadingStep}/{CONSTANT.shared.imageSizes.length} — Taille :
              <span className="ml-1 font-semibold text-slate-700">
                {loadingStep ? `${CONSTANT.shared.imageSizes[loadingStep - 1].width}px` : '-'}
              </span>
            </span>
            <div className="flex flex-row gap-x-2 items-start justify-center bg-slate-100 p-2 rounded-lg shadow-sm">
              <i className="pi pi-info-circle text-slate-500 text-sm"></i>
              <span className="text-slate-500 text-xs">
                Nous générons plusieurs tailles d’images afin d’afficher celle qui correspond le
                mieux à l’écran de l’utilisateur. Cela rend le site plus rapide et renforce son
                éco-conception.
              </span>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default ImageCompressing;
